const factory = Model => {
  class TemplateLedger extends Model {
    $url(id) {
      return `${this.$resource}.json/${id}`;
    }
  }

  TemplateLedger.prototype.$resource = 'templateledger';
  TemplateLedger.prototype.id = null;
  return TemplateLedger;
};

const moduleDeps = [require('data/util').name];

module.exports = angular
  .module('bench.data.model.templateLedger', moduleDeps)
  .factory('TemplateLedger', factory);
